class LuxFeaturedPDPReview extends HTMLElement {
    connectedCallback() {
        this.scroller = this.querySelector('.lux-featured-pdp-reviews__scroller');
        if (!this.scroller) return;

        this.slides = this.querySelectorAll('.lux-featured-pdp-review');
        if (!this.slides.length) return;

        this.button = this.querySelector('.lux-featured-pdp-reviews__button');
        if (!this.button) return;

        // Original slide count (before duplication)
        this.total = this.slides.length / 2;

        this.index = 0;
        this.isTransitioning = false;

        // Initial state
        this.update();

        this.button.addEventListener('click', () => this.next());
    }

    next() {
        if (this.isTransitioning) return;

        this.index++;
        this.animateTo(this.index);

        // When we reach the duplicated set → reset
        if (this.index === this.total) {
            this.isTransitioning = true;

            this.scroller.addEventListener('transitionend', () => {
                // Disable transition for seamless jump
                this.scroller.style.transition = 'none';

                this.index = 0;
                this.update();

                // Force reflow so browser applies transform instantly
                this.scroller.offsetHeight;

                // Re-enable transition
                this.scroller.style.transition = '';

                this.isTransitioning = false;
            }, { once: true });
        }
    }

    animateTo(index) {
        this.scroller.style.setProperty('--modifier', index);
    }

    update() {
        this.scroller.style.setProperty('--modifier', this.index);
    }
}

if (!customElements.get('lux-featured-pdp-reviews')) {
    customElements.define('lux-featured-pdp-reviews', LuxFeaturedPDPReview);
}